/** Fixed simulation step (SPEC §3.5). */
export const TICK_RATE = 60;
export const DT = 1 / 60;
export const GRAVITY = 9.81;
/** km/h per m/s. */
export const KMH = 3.6;
